import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../../utils";

export const subjectsByCourseIds = createAsyncThunk('subjectsByCourseIds', async ({ courses, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'subjects_by_course_ids',
            params: {
                "courses": Array.isArray(courses) ? courses.join(',') : courses,
                "pageSize": '',
                "pageNo": '',
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const subjectsByCourseIdsSlice = createSlice({
    name: 'subjectsByCourseIds',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(subjectsByCourseIds.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action?.payload?.data?.data?.getSubjectsByCourseIds || [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
        builder.addCase(subjectsByCourseIds.rejected, (state) => {
            state.data = []
        })
    }
})

export default subjectsByCourseIdsSlice.reducer;
